// import 'core-js/stable';
// import 'regenerator-runtime/runtime';
import 'regenerator-runtime/runtime';
import CartItemList from './components/cartitemlist.js';
import Checkout from './components/checkout.js';
import cartService from './service/CartService.js';
// import CartProvider from "./context/CartProvider.js";
import { AddAddress } from './components/modal.js';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addaddress: false,
      countries: [],
      cartcount: 0,
      price: 0,
      isloading: true,
      //  ppsRequired: window.pps_required
    };

    // this.ItemList();
    // fetch(__siteUrl + "/mykademy/api/v1/countries", {
    // 	method: "GET",
    // 	headers: {
    // 		Accept: "application/json",
    // 		"Content-Type": "application/json",
    // 	},
    // })
    // 	.then((res) => res.json())
    // 	.then((result) => {
    // 		// console.log(result);
    // 		localStorage.setItem('countries',JSON.stringify(result.data));
    // 		// this.setState({ countries: JSON.parse(localStorage.getItem('countries'))});
    // 	});
  }
  componentDidMount() {
    const change_cart = JSON.parse(localStorage.getItem('mycart')) ?? '';
    if (change_cart) {
      Object.keys(change_cart).map((key) => {
        Object.keys(change_cart[key].learners).map((item) => {
          if (change_cart[key].learners[item].discount_price && change_cart[key].learners[item].discount_price > 0) {
            change_cart[key].learners[item].is_bulk_learner_discount = 0;
            change_cart[key].learners[item].discount_price       = 0;
            change_cart[key].learners[item].total_after_discount = 0;
            localStorage.setItem('mycart', JSON.stringify(change_cart));
          }
        })
      })
    }

    let cartData = cartService.getCart();
    if (cartData && cartData !== '[]')
    {
      Object.keys(cartData).map((key) => {
        Object.keys(cartData[key].learners).map((item) => {
          if (cartData[key].learners[item].discount_price && cartData[key].learners[item].discount_price > 0) {
            cartData[key].learners[item].is_bulk_learner_discount = 0;
            cartData[key].learners[item].discount_price       = 0;
            cartData[key].learners[item].total_after_discount = 0;
            localStorage.setItem('mycart', JSON.stringify(cartData));
          }
        })
      })
    }

    const refreshMainCouponLimit = localStorage.getItem('main_coupon_limit');
    if (refreshMainCouponLimit || (typeof refreshMainCouponLimit == 'undefined')) {
      localStorage.removeItem("main_coupon_limit");
    }
  
    const refreshCouponLimit = localStorage.getItem('coupon_limit_usage');
    if (refreshCouponLimit || (typeof refreshCouponLimit == 'undefined')) {
      localStorage.removeItem("coupon_limit_usage");
    }

    const refreshLimitRemainCoupon = localStorage.getItem('limit_remaining_coupon');
    if (refreshLimitRemainCoupon || (typeof refreshLimitRemainCoupon == 'undefined')) {
      localStorage.removeItem("limit_remaining_coupon");
    }

    const refreshCouponDiscountLimitRemain = localStorage.getItem('limit_discount_remaining_coupon');
    if (refreshCouponDiscountLimitRemain || (typeof refreshCouponDiscountLimitRemain == 'undefined')) {
      localStorage.removeItem("limit_discount_remaining_coupon");
    }

    const refreshCouponDiscountCustomRemain = localStorage.getItem('limit_discount_custom_coupon');
    if (refreshCouponDiscountCustomRemain || (typeof refreshCouponDiscountCustomRemain == 'undefined')) {
      localStorage.removeItem("limit_discount_custom_coupon");
    }

    const refreshCouponLimitLearner = localStorage.getItem('coupon_limit_learner_usage');
    if (refreshCouponLimitLearner || (typeof refreshCouponLimitLearner == 'undefined')) {
      localStorage.removeItem("coupon_limit_learner_usage");
    }

    const refreshMasterLimit = localStorage.getItem('main_coupon_limit');
    if (refreshCouponLimitLearner || (typeof refreshCouponLimitLearner == 'undefined')) {
      localStorage.removeItem("main_coupon_limit");
    }

    this.setState({
      countries: JSON.parse(
        localStorage.getItem('countries')
          ? localStorage.getItem('countries')
          : '[]'
      ),
    });
    cartService.init().then((data) => {
      var totalprice = 0;
      var count = 0;
      // let ppsRequired = (data.pps_required)?data.pps_required:false;

      let res = data.data;
      for (var key of Object.keys(res)) {
        
        if (res[key].others.discount_price != 0) {
          totalprice = totalprice + Number(res[key].others.discount_price);
        } else {
          totalprice = totalprice + Number(res[key].others.price);
        }
        count++;
        
      }
      totalprice = Math.round((totalprice + Number.EPSILON) * 100) / 100;
      if (_buyNow) {
        var index = _buyNowDetails.type + '_' + _buyNowDetails.id;
        var cart = {};
        cart[index] = _buyNowDetails;
        res = cart;
      }
      this.setState({
        cartcount: count,
        price: parseInt(totalprice),
        items: res,
        isloading: false,
        itemlistkey: 1,
        checkoutkey: 1,
        global_coupon: data.global_coupon,
        // ppsRequired: window.pps_required
      });
    });
    
    //adderss fetch
    this.setState({
      address: cartService.getAddress(),
    });
  }
  refresh_address = () => {
    this.setState({
      address: cartService.getAddress(),
    });
  };
  refresh = (count, price, items, optional = null) => {
    if (optional == 'app') {
      this.setState({
        cartcount: count,
        price: price,
        items: items,
      });
    } else {
      this.setState({
        cartcount: count,
        price: price,
        items: items,
        checkoutkey: Math.random(),
        itemlistkey: Math.random(),
      });
    }
  };

  couponappliedtrigger = () => {
    this.setState({
      itemlistkey: Math.random(),
      checkoutkey: Math.random(),
    });
  };

  // var  = "window.location='"+__SiteUrl+"'";
  keep_shopping = () => {
    window.location = __SiteUrl + 'course/listing';
  };
  addaddress = () => {
    this.setState({
      addaddress: true,
    });
  };

  dissmissmodal = () => {
    this.setState({
      addaddress: false,
    });
  };

  render() {
    var address = this.state.address;
    if (__invalidCoupon && !_couponApplied.slug) {
      $('#coupon-error').modal('show');
      __invalidCoupon = false;
    }
    // let obj = arr.find(o => o.name === 'string 1');
    return !this.state.isloading ? (
      <div className="cart_block_center_align">
        <div className="container">
          <div className="col-md-12 center_align_grid sm-pd-0 mt-4">
            {Object.keys(this.state.items).length ? (
              <div className="row sm-reverse-flex d-block">
                <div className="col-md-8 sm-mr-o pr-5 pr-sm-15 bill-address-row">
                  {/* billing-address box start */}
                  {_bfo != 0 && (
                    <div className="d-flex align-center justify-content-between  w-100 mb-1 mt-25">
                      <h3>Billing Address</h3>
                    </div>
                  )}
                  {_bfo != 0 && (
                    <div className="cart-box billing-box">
                      {Object.keys(address).length == 0 && (
                        <div
                          className="d-flex w-100"
                          style={{ justifyContent: 'space-between' }}
                        >
                          <div
                            className="cart-bulk-text"
                            onClick={this.addaddress}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18.256"
                              height="19.201"
                              viewBox="0 0 18.256 19.201"
                            >
                              <path
                                id="Path_6"
                                data-name="Path 6"
                                d="M18.156,4.237a.777.777,0,0,0-.54-.8Q13.553,1.766,9.49.094a1.193,1.193,0,0,0-.945,0c-.765.325-1.534.635-2.3.95L.4,3.448a.688.688,0,0,0-.5.745v10.83a.687.687,0,0,0,.49.735c.865.36,1.734.715,2.6,1.069q2.384.982,4.768,1.959a6.409,6.409,0,0,0,1.119.415h.3a2.988,2.988,0,0,0,.425-.13l2.579-1.064c1.814-.745,3.628-1.484,5.442-2.239a.7.7,0,0,0,.525-.785C18.151,11.4,18.146,7.821,18.156,4.237ZM3.868,3.388c1.654-.68,3.3-1.354,4.953-2.039a.487.487,0,0,1,.425,0c.6.26,1.214.5,1.864.77-2.1.915-4.168,1.8-6.227,2.724a1.119,1.119,0,0,1-1.044.015c-.565-.275-1.159-.485-1.774-.74ZM8.426,17.626c-.055.03-.095-.01-.135-.025q-3.508-1.439-7.012-2.874a.176.176,0,0,1-.13-.19q.007-4.693,0-9.385c0-.165.06-.135.16-.09q1.2.495,2.4.985a.2.2,0,0,1,.14.225c0,.985,0,1.974,0,2.959A.6.6,0,0,0,5,9.46a.816.816,0,0,0,.05-.33V6.6c.5.2.995.4,1.479.6.59.24,1.174.485,1.759.725.085.035.14.065.14.18Q8.423,12.863,8.426,17.626Zm.745-10.7a.3.3,0,0,1-.245.02Q7.494,6.354,6.062,5.767c-.045-.02-.085-.04-.14-.07Q9.25,4.242,12.554,2.8a.241.241,0,0,1,.195-.01l3.243,1.334-2.164.885Q11.5,5.966,9.171,6.926Zm7.546,7.826Q13.246,16.169,9.775,17.6c-.04.015-.08.03-.145.06V8.16c0-.11.01-.175.13-.225Q13.276,6.5,16.792,5.052c.03-.01.055-.02.115-.045v.21q0,4.625,0,9.256A.261.261,0,0,1,16.717,14.752Z"
                                transform="translate(0.1 0.001)"
                                opacity="0.423"
                              ></path>
                            </svg>
                            Add billing address
                          </div>
                          <a
                            style={{ textDecoration: 'none' }}
                            className="bill-address_btn apply-text"
                            onClick={this.addaddress}
                          >
                            <span class="mobile-hide">Add Address</span>
                          </a>
                        </div>
                      )}
                      {/* address-entry sample */}
                      {_bfo && address && Object.keys(address).length != 0 && (
                        <div
                          className="d-flex w-100 learner_billing_detail"
                          style={{ justifyContent: 'space-between' }}
                        >
                          <div className="cart-bulk-text">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18.256"
                              height="19.201"
                              viewBox="0 0 18.256 19.201"
                            >
                              <path
                                id="Path_6"
                                data-name="Path 6"
                                d="M18.156,4.237a.777.777,0,0,0-.54-.8Q13.553,1.766,9.49.094a1.193,1.193,0,0,0-.945,0c-.765.325-1.534.635-2.3.95L.4,3.448a.688.688,0,0,0-.5.745v10.83a.687.687,0,0,0,.49.735c.865.36,1.734.715,2.6,1.069q2.384.982,4.768,1.959a6.409,6.409,0,0,0,1.119.415h.3a2.988,2.988,0,0,0,.425-.13l2.579-1.064c1.814-.745,3.628-1.484,5.442-2.239a.7.7,0,0,0,.525-.785C18.151,11.4,18.146,7.821,18.156,4.237ZM3.868,3.388c1.654-.68,3.3-1.354,4.953-2.039a.487.487,0,0,1,.425,0c.6.26,1.214.5,1.864.77-2.1.915-4.168,1.8-6.227,2.724a1.119,1.119,0,0,1-1.044.015c-.565-.275-1.159-.485-1.774-.74ZM8.426,17.626c-.055.03-.095-.01-.135-.025q-3.508-1.439-7.012-2.874a.176.176,0,0,1-.13-.19q.007-4.693,0-9.385c0-.165.06-.135.16-.09q1.2.495,2.4.985a.2.2,0,0,1,.14.225c0,.985,0,1.974,0,2.959A.6.6,0,0,0,5,9.46a.816.816,0,0,0,.05-.33V6.6c.5.2.995.4,1.479.6.59.24,1.174.485,1.759.725.085.035.14.065.14.18Q8.423,12.863,8.426,17.626Zm.745-10.7a.3.3,0,0,1-.245.02Q7.494,6.354,6.062,5.767c-.045-.02-.085-.04-.14-.07Q9.25,4.242,12.554,2.8a.241.241,0,0,1,.195-.01l3.243,1.334-2.164.885Q11.5,5.966,9.171,6.926Zm7.546,7.826Q13.246,16.169,9.775,17.6c-.04.015-.08.03-.145.06V8.16c0-.11.01-.175.13-.225Q13.276,6.5,16.792,5.052c.03-.01.055-.02.115-.045v.21q0,4.625,0,9.256A.261.261,0,0,1,16.717,14.752Z"
                                transform="translate(0.1 0.001)"
                                opacity="0.423"
                              ></path>
                            </svg>
                            <b>{address.full_name}</b>
                          </div>
                          <p className="address apply-small-text m-0">
                            {address.email}, +
                            {address.country_code && this.state.countries
                              ? this.state.countries.find(
                                  (o) => o.id === address.country_code
                                )
                                ? this.state.countries.find(
                                    (o) => o.id === address.country_code
                                  ).calling_code
                                : ''
                              : ''}{' '}
                            {address.phone} {address.street_po} {address.subrub}{' '}
                            {address.county} {address.city}{' '}
                            {address.country && this.state.countries
                              ? this.state.countries.find(
                                  (o) => o.id === address.country
                                )
                                ? this.state.countries.find(
                                    (o) => o.id === address.country
                                  ).country_name
                                : ''
                              : ''}{' '}
                            {address.postcode}
                          </p>
                          <a
                            style={{ textDecoration: 'none' }}
                            className="bill-address_btn apply-text"
                            onClick={this.addaddress}
                          >
                            Edit <span class="mobile-view"> Address</span>
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                  {this.state.addaddress && (
                    <AddAddress
                      refresh={this.refresh_address}
                      dissmissmodal={this.dissmissmodal}
                    />
                  )}
                  {/* billing-address box end */}
                  {/* mt-25 */}
                </div>
                <div className="col-md-8 sm-mr-o pr-5 pr-sm-15">
                  {/* billing-address box end */}
                  {/* mt-25 */}
                  <div
                    className={
                      'd-flex align-center justify-content-between  w-100 mb-1 mt-25' +
                      (_buyNow ? ' hide_cart_extras' : '')
                    }
                  >
                    {this.state.cartcount && !_buyNow ? (
                      <h3>
                        My Cart <span>
                                  {'('+this.state.cartcount + ' Items)'}
                                </span>
                      </h3>
                    ) : (
                      <h3>Order Summary</h3>
                    )}
                    {this.state.cartcount && !_buyNow ? (
                      <span className="total-price">
                        Total: {current_currency}
                        {this.state.price}
                      </span>
                    ) : (
                      <div></div>
                    )}
                  </div>

                  <CartItemList
                    key={this.state.itemlistkey}
                    couponappliedtrigger={this.couponappliedtrigger}
                    refresh={this.refresh}
                  />
                </div>
                <div
                  className="col-md-4 sm-pd-0"
                  style={{ display: 'inline-block', float: 'none' }}
                >
                  {this.state.cartcount || _buyNow ? (
                    <Checkout
                      key={this.state.checkoutkey}
                      couponappliedtrigger={this.couponappliedtrigger}
                      refresh={this.refresh}
                      data={this.state}
                    />
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            ) : (
              <div className="cart_empty cart_align_center">
                <div className="cart_empty_icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="204.543"
                    height="125.543"
                    viewBox="0 0 204.543 125.543"
                  >
                    <g id="sv" transform="translate(0 0)">
                      <path
                        id="Path_114"
                        data-name="Path 114"
                        d="M324.9,471.482H268.142a3.755,3.755,0,0,1-3.6-2.649l-20.373-66.067a.779.779,0,0,0-.779-.53H229.818a1.558,1.558,0,0,1,0-3.116h13.6a3.9,3.9,0,0,1,3.716,2.711l20.389,66.059a.639.639,0,0,0,.616.452H324.9a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-176.388 -366.975)"
                        fill="#5c7ce7"
                      />
                      <path
                        id="Path_115"
                        data-name="Path 115"
                        d="M271.053,463.334H330.5a2.213,2.213,0,0,0,2.1-1.558l12.208-38a2.213,2.213,0,0,0-2.1-2.883l-83.363-.039a2.2,2.2,0,0,0-2.111,2.859l11.733,38.035a2.213,2.213,0,0,0,2.088,1.589Z"
                        transform="translate(-182.766 -371.775)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_116"
                        data-name="Path 116"
                        d="M330.331,463.622H270.925a2.587,2.587,0,0,1-2.485-1.831l-11.772-38.035a2.6,2.6,0,0,1,2.477-3.366h0l83.363.039a2.6,2.6,0,0,1,2.477,3.4l-12.208,38A2.594,2.594,0,0,1,330.331,463.622Zm-71.186-42.453a1.831,1.831,0,0,0-1.737,2.337l11.741,38.035a1.808,1.808,0,0,0,1.737,1.278h59.445a1.823,1.823,0,0,0,1.737-1.262l12.2-38a1.815,1.815,0,0,0-1.73-2.376l-83.363-.039Z"
                        transform="translate(-182.638 -371.673)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_117"
                        data-name="Path 117"
                        d="M279.263,439.638H265.426a1.091,1.091,0,0,1-1.052-.779l-4.449-14.476a1.106,1.106,0,0,1,1.052-1.434h15.06a1.091,1.091,0,0,1,1.075.865l3.233,14.483a1.1,1.1,0,0,1-1.083,1.34Z"
                        transform="translate(-183.372 -372.239)"
                        fill="#fff"
                      />
                      <path
                        id="Path_118"
                        data-name="Path 118"
                        d="M279.207,439.786H265.37a1.285,1.285,0,0,1-1.239-.919l-4.449-14.483a1.27,1.27,0,0,1,.195-1.153,1.293,1.293,0,0,1,1.044-.53h15.06a1.293,1.293,0,0,1,1.27,1.021l3.225,14.476a1.3,1.3,0,0,1-1.262,1.558Zm-18.293-16.7a.912.912,0,0,0-.732.374.9.9,0,0,0-.14.779l4.456,14.483a.911.911,0,0,0,.865.647h13.844a.919.919,0,0,0,.709-.343.943.943,0,0,0,.179-.779l-3.233-14.476a.911.911,0,0,0-.888-.717Z"
                        transform="translate(-183.316 -372.184)"
                        fill="#fff"
                      />
                      <path
                        id="Path_119"
                        data-name="Path 119"
                        d="M305.095,439.638h-14.53a1.106,1.106,0,0,1-1.083-.88l-2.968-14.476a1.106,1.106,0,0,1,1.083-1.332h17.53a1.106,1.106,0,0,1,1.106,1.106V438.54a1.1,1.1,0,0,1-1.138,1.1Z"
                        transform="translate(-189.252 -372.239)"
                        fill="#fff"
                      />
                      <path
                        id="Path_120"
                        data-name="Path 120"
                        d="M305.04,439.786H290.51a1.317,1.317,0,0,1-1.27-1.044l-2.968-14.475a1.286,1.286,0,0,1,.265-1.083,1.3,1.3,0,0,1,1.005-.483h17.53a1.3,1.3,0,0,1,1.3,1.309l-.062,14.507a1.3,1.3,0,0,1-1.27,1.27Zm-17.5-16.7a.912.912,0,0,0-.888,1.1l2.968,14.475a.919.919,0,0,0,.888.732h14.53a.912.912,0,0,0,.912-.912V424a.918.918,0,0,0-.911-.912Z"
                        transform="translate(-189.197 -372.184)"
                        fill="#fff"
                      />
                      <path
                        id="Path_121"
                        data-name="Path 121"
                        d="M330.867,439.638H317.389a1.1,1.1,0,0,1-1.1-1.1V424.056a1.106,1.106,0,0,1,1.1-1.106H333.9a1.106,1.106,0,0,1,1.083,1.332L332,438.758A1.1,1.1,0,0,1,330.867,439.638Z"
                        transform="translate(-195.835 -372.239)"
                        fill="#fff"
                      />
                      <path
                        id="Path_122"
                        data-name="Path 122"
                        d="M330.8,439.794H317.324a1.3,1.3,0,0,1-1.324-1.27V424.049a1.293,1.293,0,0,1,1.293-1.309H333.8a1.3,1.3,0,0,1,1.27,1.558L332.1,438.774a1.309,1.309,0,0,1-1.293,1.021Zm-13.509-16.7a.919.919,0,0,0-.9.912v14.483a.911.911,0,0,0,.9.911H330.8a.919.919,0,0,0,.9-.732l3-14.476a.9.9,0,0,0-.888-1.1Z"
                        transform="translate(-195.77 -372.193)"
                        fill="#fff"
                      />
                      <path
                        id="Path_123"
                        data-name="Path 123"
                        d="M355.619,439.638H342.156a1.1,1.1,0,0,1-1.083-1.324l2.976-14.476a1.114,1.114,0,0,1,1.083-.888h14.959a1.106,1.106,0,0,1,1.06,1.434l-4.472,14.483a1.1,1.1,0,0,1-1.06.771Z"
                        transform="translate(-201.304 -372.239)"
                        fill="#fff"
                      />
                      <path
                        id="Path_124"
                        data-name="Path 124"
                        d="M355.563,439.779H342.1a1.309,1.309,0,0,1-1.013-.483,1.325,1.325,0,0,1-.265-1.083l2.984-14.507a1.3,1.3,0,0,1,1.27-1.036h14.959a1.3,1.3,0,0,1,1.247,1.683l-4.472,14.483a1.3,1.3,0,0,1-1.247.943Zm-10.487-16.7a.912.912,0,0,0-.888.725L341.2,438.291a.927.927,0,0,0,.187.779.911.911,0,0,0,.709.335h13.463a.912.912,0,0,0,.873-.647l4.472-14.483a.88.88,0,0,0-.14-.779.9.9,0,0,0-.732-.374Z"
                        transform="translate(-201.249 -372.177)"
                        fill="#fff"
                      />
                      <path
                        id="Path_125"
                        data-name="Path 125"
                        d="M285.462,467.349H273.931a1.106,1.106,0,0,1-1.052-.779l-4.893-16.182a1.1,1.1,0,0,1,1.06-1.418l13.011.093a1.106,1.106,0,0,1,1.075.88l3.389,16.073a1.1,1.1,0,0,1-1.06,1.332Z"
                        transform="translate(-185.153 -377.987)"
                        fill="#fff"
                      />
                      <path
                        id="Path_126"
                        data-name="Path 126"
                        d="M285.41,467.488H273.88a1.3,1.3,0,0,1-1.239-.919L267.764,450.4A1.293,1.293,0,0,1,269,448.72h0l13,.093a1.309,1.309,0,0,1,1.262,1.028l3.4,16.08a1.309,1.309,0,0,1-.265,1.091,1.293,1.293,0,0,1-.989.475ZM269,449.11a.9.9,0,0,0-.725.358.888.888,0,0,0-.14.779l4.877,16.174a.9.9,0,0,0,.865.647H285.41a.912.912,0,0,0,.888-1.091L282.9,449.9a.9.9,0,0,0-.88-.725l-13.011-.094Z"
                        transform="translate(-185.102 -377.932)"
                        fill="#fff"
                      />
                      <path
                        id="Path_127"
                        data-name="Path 127"
                        d="M336.037,467.349H347.56a1.106,1.106,0,0,0,1.06-.779l4.877-16.182a1.1,1.1,0,0,0-1.067-1.418l-13,.094a1.106,1.106,0,0,0-1.075.88l-3.358,16.073a1.106,1.106,0,0,0,1.044,1.332Z"
                        transform="translate(-199.961 -377.987)"
                        fill="#fff"
                      />
                      <path
                        id="Path_128"
                        data-name="Path 128"
                        d="M347.494,467.491H335.972a1.286,1.286,0,0,1-1.27-1.558l3.389-16.08a1.317,1.317,0,0,1,1.262-1.028l13.011-.093h0a1.278,1.278,0,0,1,1.036.514,1.293,1.293,0,0,1,.21,1.161l-4.877,16.174a1.293,1.293,0,0,1-1.239.912Zm4.877-18.379h0l-13,.093a.912.912,0,0,0-.888.725l-3.389,16.08a.88.88,0,0,0,.179.779.9.9,0,0,0,.709.335H347.5a.9.9,0,0,0,.873-.647l4.877-16.174a.911.911,0,0,0-.14-.779A.927.927,0,0,0,352.372,449.112Z"
                        transform="translate(-199.895 -377.934)"
                        fill="#fff"
                      />
                      <path
                        id="Path_129"
                        data-name="Path 129"
                        d="M306.347,467.294H296.78a1.1,1.1,0,0,1-1.075-.865l-3.662-16.361a1.114,1.114,0,0,1,1.083-1.348H306.37a1.106,1.106,0,0,1,1.106,1.106v16.361a1.1,1.1,0,0,1-1.13,1.106Z"
                        transform="translate(-190.473 -377.932)"
                        fill="#fff"
                      />
                      <path
                        id="Path_130"
                        data-name="Path 130"
                        d="M306.294,467.442h-9.567a1.285,1.285,0,0,1-1.262-1.013L291.8,450.068a1.309,1.309,0,0,1,1.27-1.558h13.245a1.3,1.3,0,0,1,1.3,1.3v16.361a1.293,1.293,0,0,1-1.324,1.27Zm-13.245-18.6a.9.9,0,0,0-.709.343.88.88,0,0,0-.179.779l3.654,16.361a.9.9,0,0,0,.888.709h9.567a.9.9,0,0,0,.912-.9V449.772a.912.912,0,0,0-.912-.912Z"
                        transform="translate(-190.42 -377.885)"
                        fill="#fff"
                      />
                      <path
                        id="Path_131"
                        data-name="Path 131"
                        d="M317.317,467.294h9.295a1.075,1.075,0,0,0,1.044-.865l3.553-16.361a1.091,1.091,0,0,0-1.044-1.348H317.317a1.091,1.091,0,0,0-1.067,1.106v16.361a1.083,1.083,0,0,0,1.067,1.106Z"
                        transform="translate(-195.826 -377.932)"
                        fill="#fff"
                      />
                      <path
                        id="Path_132"
                        data-name="Path 132"
                        d="M326.557,467.435h-9.295A1.278,1.278,0,0,1,316,466.142V449.781a1.285,1.285,0,0,1,1.262-1.3h12.847a1.231,1.231,0,0,1,.974.475,1.286,1.286,0,0,1,.265,1.106L327.8,466.422A1.262,1.262,0,0,1,326.557,467.435Zm-9.295-18.6a.9.9,0,0,0-.873.912v16.361a.888.888,0,0,0,.873.9h9.295a.88.88,0,0,0,.857-.709l3.553-16.361a.919.919,0,0,0-.187-.779.849.849,0,0,0-.67-.327Z"
                        transform="translate(-195.77 -377.879)"
                        fill="#fff"
                      />
                      <path
                        id="Path_133"
                        data-name="Path 133"
                        d="M279.548,512.346A8.648,8.648,0,1,1,288.2,503.7a8.648,8.648,0,0,1-8.648,8.648Zm0-14.18a5.532,5.532,0,1,0,5.532,5.532,5.532,5.532,0,0,0-5.532-5.532Z"
                        transform="translate(-185.808 -388.166)"
                        fill="#5d7ee7"
                      />
                      <circle
                        id="Ellipse_114"
                        data-name="Ellipse 114"
                        cx="1.917"
                        cy="1.917"
                        r="1.917"
                        transform="translate(91.824 113.615)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_134"
                        data-name="Path 134"
                        d="M342.7,512.346a8.648,8.648,0,1,1,8.648-8.648,8.648,8.648,0,0,1-8.648,8.648Zm0-14.18a5.532,5.532,0,1,0,5.532,5.532A5.532,5.532,0,0,0,342.7,498.166Z"
                        transform="translate(-199.758 -388.166)"
                        fill="#5d7ee7"
                      />
                      <circle
                        id="Ellipse_115"
                        data-name="Ellipse 115"
                        cx="1.917"
                        cy="1.917"
                        r="1.917"
                        transform="translate(141.023 113.615)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_135"
                        data-name="Path 135"
                        d="M260.63,434.776H244.448a1.558,1.558,0,0,1,0-3.116H260.63a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-179.62 -374.163)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_136"
                        data-name="Path 136"
                        d="M235.7,434.776h-3.841a1.558,1.558,0,1,1,0-3.116H235.7a1.558,1.558,0,0,1,0,3.116Z"
                        transform="translate(-176.839 -374.163)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_137"
                        data-name="Path 137"
                        d="M217.976,461.746h-6.038a1.558,1.558,0,1,1,0-3.116h6.038a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-172.438 -380.121)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_138"
                        data-name="Path 138"
                        d="M243.377,461.886H229.088a1.558,1.558,0,1,1,0-3.116h14.289a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-176.227 -380.152)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_139"
                        data-name="Path 139"
                        d="M205.781,461.886h-.623a1.558,1.558,0,0,1,0-3.116h.623a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-170.94 -380.152)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_140"
                        data-name="Path 140"
                        d="M255.831,496.2h-4.573a1.558,1.558,0,1,1,0-3.116h4.573a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-181.124 -387.731)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_141"
                        data-name="Path 141"
                        d="M238.841,496.2h-8.983a1.558,1.558,0,1,1,0-3.116h8.983a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-176.397 -387.731)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_142"
                        data-name="Path 142"
                        d="M263.1,496.2H247.388a1.558,1.558,0,1,1,0-3.116H263.1a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-180.269 -387.731)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_143"
                        data-name="Path 143"
                        d="M351.129,518.116H195.178a1.558,1.558,0,0,1,0-3.116H351.129a1.558,1.558,0,0,1,0,3.116Z"
                        transform="translate(-168.736 -392.573)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_144"
                        data-name="Path 144"
                        d="M222.692,496.2h-3.514a1.558,1.558,0,1,1,0-3.116h3.514a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-174.038 -387.731)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_145"
                        data-name="Path 145"
                        d="M407.162,518.116h-3.514a1.558,1.558,0,0,1,0-3.116h3.514a1.558,1.558,0,0,1,0,3.116Z"
                        transform="translate(-214.788 -392.573)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_146"
                        data-name="Path 146"
                        d="M421.075,518.116h-2.517a1.558,1.558,0,0,1,0-3.116h2.509a1.558,1.558,0,1,1,0,3.116Z"
                        transform="translate(-218.082 -392.573)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_147"
                        data-name="Path 147"
                        d="M181.461,518.116h-8.983a1.558,1.558,0,0,1,0-3.116h8.983a1.558,1.558,0,0,1,0,3.116Z"
                        transform="translate(-163.721 -392.573)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_148"
                        data-name="Path 148"
                        d="M282.7,392.148a.39.39,0,0,1-.39-.39V383.89a.39.39,0,0,1,.779,0v7.869A.39.39,0,0,1,282.7,392.148Z"
                        transform="translate(-188.328 -363.524)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_149"
                        data-name="Path 149"
                        d="M285.766,389.339H277.89a.39.39,0,0,1,0-.779h7.861a.39.39,0,1,1,0,.779Z"
                        transform="translate(-187.266 -364.642)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_150"
                        data-name="Path 150"
                        d="M254.746,377.811a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,254.746,377.811Zm0-3.412a.547.547,0,1,0,0-.023Z"
                        transform="translate(-181.776 -361.341)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_151"
                        data-name="Path 151"
                        d="M217.6,377.577a.732.732,0,0,0,1.052.039l2.143-2.142a.78.78,0,1,0-1.106-1.1l-2.143,2.142a.732.732,0,0,0,.047,1.044Z"
                        transform="translate(-173.978 -361.457)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_152"
                        data-name="Path 152"
                        d="M217.6,381.633h0a.732.732,0,0,0-.047,1.044l2.143,2.142a.78.78,0,1,0,1.106-1.1l-2.166-2.127a.732.732,0,0,0-1.036.039Z"
                        transform="translate(-173.98 -363.06)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_153"
                        data-name="Path 153"
                        d="M213.52,381.631a.732.732,0,0,0-1.052-.039l-2.142,2.143a.78.78,0,0,0,1.106,1.1l2.143-2.143a.732.732,0,0,0-.047-1.044Z"
                        transform="translate(-172.376 -363.058)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_154"
                        data-name="Path 154"
                        d="M213.528,377.561a.732.732,0,0,0,.047-1.044l-2.143-2.142a.78.78,0,0,0-1.106,1.1l2.143,2.143a.732.732,0,0,0,1.052-.039Z"
                        transform="translate(-172.376 -361.457)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_155"
                        data-name="Path 155"
                        d="M172.342,446.85a.522.522,0,0,0,.779,0l1.558-1.558a.561.561,0,0,0-.779-.779l-1.558,1.558a.53.53,0,0,0,0,.779Z"
                        transform="translate(-163.998 -376.981)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_156"
                        data-name="Path 156"
                        d="M172.342,449.76h0a.53.53,0,0,0,0,.779L173.9,452.1a.561.561,0,0,0,.779-.779l-1.558-1.558a.522.522,0,0,0-.779,0Z"
                        transform="translate(-163.998 -378.123)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_157"
                        data-name="Path 157"
                        d="M169.39,449.76a.522.522,0,0,0-.779,0l-1.558,1.558a.561.561,0,0,0,.4.958.553.553,0,0,0,.4-.164l1.558-1.558a.53.53,0,0,0,0-.779Z"
                        transform="translate(-162.831 -378.123)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_158"
                        data-name="Path 158"
                        d="M169.42,446.84a.53.53,0,0,0,0-.779l-1.558-1.558a.561.561,0,0,0-.779.779l1.558,1.558a.522.522,0,0,0,.779,0Z"
                        transform="translate(-162.852 -376.979)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_159"
                        data-name="Path 159"
                        d="M205.292,483.85a.522.522,0,0,0,.779,0l1.558-1.558a.561.561,0,0,0-.779-.779l-1.558,1.558a.53.53,0,0,0,0,.779Z"
                        transform="translate(-171.276 -385.154)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_160"
                        data-name="Path 160"
                        d="M205.292,486.76h0a.53.53,0,0,0,0,.779l1.558,1.558a.561.561,0,0,0,.779,0,.553.553,0,0,0,0-.779l-1.558-1.558a.522.522,0,0,0-.779,0Z"
                        transform="translate(-171.276 -386.297)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_161"
                        data-name="Path 161"
                        d="M202.342,486.76a.522.522,0,0,0-.779,0L200,488.319a.553.553,0,0,0,0,.779.569.569,0,0,0,.4.164.553.553,0,0,0,.4-.164l1.558-1.558a.53.53,0,0,0,0-.779Z"
                        transform="translate(-170.111 -386.297)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_162"
                        data-name="Path 162"
                        d="M202.37,483.84a.53.53,0,0,0,0-.779l-1.558-1.558a.561.561,0,0,0-.779.779l1.558,1.558a.522.522,0,0,0,.779,0Z"
                        transform="translate(-170.131 -385.152)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_163"
                        data-name="Path 163"
                        d="M179.988,405.175a3.218,3.218,0,1,1,3.218-3.21A3.218,3.218,0,0,1,179.988,405.175Zm0-5.648a1.011,1.011,0,1,0,0-.008Z"
                        transform="translate(-165.013 -366.891)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_164"
                        data-name="Path 164"
                        d="M213.1,417.561a2.22,2.22,0,1,1,2.213-2.213,2.22,2.22,0,0,1-2.213,2.213Zm0-3.654a1.441,1.441,0,1,0,1.434,1.441,1.441,1.441,0,0,0-1.434-1.441Z"
                        transform="translate(-172.546 -370.067)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_165"
                        data-name="Path 165"
                        d="M166.85,365.58v2.82h.779v-2.82a1.558,1.558,0,0,1-.39.047A1.668,1.668,0,0,1,166.85,365.58Z"
                        transform="translate(-162.822 -359.565)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_166"
                        data-name="Path 166"
                        d="M164.987,364.62,163,366.614l.553.553,1.994-1.994a1.706,1.706,0,0,1-.561-.553Z"
                        transform="translate(-161.972 -359.353)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_167"
                        data-name="Path 167"
                        d="M164.508,363H161.68v.779h2.828a1.418,1.418,0,0,1,0-.779Z"
                        transform="translate(-161.68 -358.995)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_168"
                        data-name="Path 168"
                        d="M167.629,360.68v-2.82h-.779v2.82a1.664,1.664,0,0,1,.39-.047,1.556,1.556,0,0,1,.39.047Z"
                        transform="translate(-162.822 -357.86)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_169"
                        data-name="Path 169"
                        d="M165.538,361.164l-1.995-1.994-.553.545,1.994,2A1.636,1.636,0,0,1,165.538,361.164Z"
                        transform="translate(-161.969 -358.149)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_170"
                        data-name="Path 170"
                        d="M168.45,365.173l1.994,1.994.553-.553L169,364.62A1.706,1.706,0,0,1,168.45,365.173Z"
                        transform="translate(-163.176 -359.353)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_171"
                        data-name="Path 171"
                        d="M169.4,363.779h2.8V363h-2.8a1.418,1.418,0,0,1,0,.779Z"
                        transform="translate(-163.385 -358.995)"
                        fill="#5d7ee7"
                      />
                      <path
                        id="Path_172"
                        data-name="Path 172"
                        d="M169,361.718l1.994-2-.553-.545-1.994,1.994a1.636,1.636,0,0,1,.553.553Z"
                        transform="translate(-163.176 -358.149)"
                        fill="#5d7ee7"
                      />
                    </g>
                  </svg>
                </div>

                <p> Your cart is empty. Keep shopping to find a course! </p>
                <button
                  className="btn mt-2 mt-50 keep-shopping-btn theme-blue-btn1"
                  onClick={this.keep_shopping}
                >
                  Keep shopping
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    ) : (
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <div className="d-flex align-center justify-content-between  w-100 mb-1 mt-25">
              <h3 className="eloads" style={{ width: 139, height: 23 }} />
              <span
                className="eloads total-price"
                style={{ height: 20, width: 100 }}
              />
            </div>
            <div className="cart-box">
              <div className="d-flex justify-content-between">
                <div className="d-flex sm-d-block">
                  <div className="cart-img">
                    <div
                      style={{ width: 178, height: 104 }}
                      className="eloads"
                    />
                  </div>
                  <div className="cart-text">
                    <div
                      className="eloads"
                      style={{ width: 230, height: 20 }}
                    />
                    <p
                      className="eloads"
                      style={{ width: 100, marginTop: 5, height: 14 }}
                    />
                  </div>
                </div>
                <div className="cart-price">
                  <b className="eloads" style={{ height: 23 }} />
                  <span className="eloads " style={{ width: 32, height: 20 }} />
                </div>
                <div
                  className="cart-text"
                  style={{ position: 'absolute', right: 20 }}
                >
                  <div className="eloads" style={{ width: 100, height: 30 }} />
                  <p
                    className="eloads"
                    style={{ width: 100, marginTop: 5, height: 14 }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end w-100">
                <div
                  className="applied-coupon d-flex eloads"
                  style={{ width: 127 }}
                />
              </div>
            </div>
            <div className="cart-box">
              <div className="d-flex justify-content-between">
                <div className="d-flex sm-d-block">
                  <div className="cart-img">
                    <div
                      style={{ width: 178, height: 104 }}
                      className="eloads"
                    />
                  </div>
                  <div className="cart-text">
                    <div
                      className="eloads"
                      style={{ width: 230, height: 20 }}
                    />
                    <p
                      className="eloads"
                      style={{ width: 100, marginTop: 5, height: 14 }}
                    />
                  </div>
                </div>
                <div className="cart-price">
                  <b className="eloads" style={{ height: 23 }} />
                  <span className="eloads " style={{ width: 32, height: 20 }} />
                </div>
                <div
                  className="cart-text"
                  style={{ position: 'absolute', right: 20 }}
                >
                  <div className="eloads" style={{ width: 100, height: 30 }} />
                  <p
                    className="eloads"
                    style={{ width: 100, marginTop: 5, height: 14 }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end w-100">
                <div
                  className="applied-coupon d-flex eloads"
                  style={{ width: 127 }}
                />
              </div>
            </div>
            <div className="cart-box">
              <div className="d-flex justify-content-between">
                <div className="d-flex sm-d-block">
                  <div className="cart-img">
                    <div
                      style={{ width: 178, height: 104 }}
                      className="eloads"
                    />
                  </div>
                  <div className="cart-text">
                    <div
                      className="eloads"
                      style={{ width: 230, height: 20 }}
                    />
                    <p
                      className="eloads"
                      style={{ width: 100, marginTop: 5, height: 14 }}
                    />
                  </div>
                </div>
                <div className="cart-price">
                  <b className="eloads" style={{ height: 23 }} />
                  <span className="eloads " style={{ width: 32, height: 20 }} />
                </div>
                <div
                  className="cart-text"
                  style={{ position: 'absolute', right: 20 }}
                >
                  <div className="eloads" style={{ width: 100, height: 30 }} />
                  <p
                    className="eloads"
                    style={{ width: 100, marginTop: 5, height: 14 }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end w-100">
                <div
                  className="applied-coupon d-flex eloads"
                  style={{ width: 127 }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4 sm-pd-0">
            <div className="cart-rght-box">
              <div className="apply-coupon">
                <div className="d-flex eloads" style={{ height: 45 }} />
                <div
                  className="apply-small-text eloads"
                  style={{ height: 20 }}
                />
              </div>

              <div className="border-bottom" />
              <div
                className="eloads mb-2 mt-2"
                style={{ height: 20, width: '50%' }}
              />
              <div className="cart-price-list">
                <div
                  className="d-flex eloads justify-content-between mb-15 w-100"
                  style={{ height: 23 }}
                >
                  <div />
                </div>
                <div
                  className="d-flex eloads justify-content-between mb-15 w-100"
                  style={{ height: 23 }}
                >
                  <div />
                </div>
                <div
                  className="d-flex eloads justify-content-between mb-15 w-100"
                  style={{ height: 23 }}
                >
                  <div />
                </div>
                <div className="border-bottom mb-15 mt-2" />
                <div
                  className="d-flex eloads justify-content-between mb-15 w-100"
                  style={{ height: 25 }}
                ></div>
                <div
                  className="d-flex eloads justify-content-between mb-15 w-100"
                  style={{ height: 25 }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('cartBlock'));
